import { create } from 'zustand';

const STORAGE_KEY = 'crawel-theme';

const systemPrefersDark = () =>
  window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;

const applyTheme = (theme) => {
  const isDark = theme === 'dark' || (theme === 'system' && systemPrefersDark());
  document.documentElement.classList.toggle('dark', isDark);
  return isDark;
};

/**
 * Tema aplikasi. Pilihan "system" mengikuti pengaturan sistem operasi dan
 * ikut berubah secara langsung bila pengguna menggantinya - itulah sebabnya
 * kami tetap mendengarkan `matchMedia` alih-alih membaca sekali di awal.
 */
export const useThemeStore = create((set, get) => ({
  theme: localStorage.getItem(STORAGE_KEY) ?? 'system',
  isDark: false,

  init() {
    const theme = get().theme;
    set({ isDark: applyTheme(theme) });

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      if (get().theme === 'system') set({ isDark: applyTheme('system') });
    };
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  },

  setTheme(theme) {
    localStorage.setItem(STORAGE_KEY, theme);
    set({ theme, isDark: applyTheme(theme) });
  },

  toggle() {
    get().setTheme(get().isDark ? 'light' : 'dark');
  },
}));
